import { Component, DestroyRef, DoCheck, ElementRef, ViewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormControl } from '@angular/forms';
import { TsInputComponent } from 'tsui';

import { FormFieldUtils } from '@shared/Utils';
import { FormFieldComponent } from '../form-field.types';

@Component({
  templateUrl: './url-form-field.component.html',
  styleUrls: ['./url-form-field.component.scss'],
})
export class UrlFormFieldComponent extends FormFieldComponent implements DoCheck {
  @ViewChild(TsInputComponent) private readonly tsInput?: TsInputComponent;

  private _originalValue: string;

  public editing: boolean = false;
  public value: string;
  public readonly control = new FormControl('');
  // Overrides the inherited Material-specific selector: ts-input has no .mat-form-field-flex to target.
  public readonly commonTargetStylingClass = '.ts-input';

  // Duck-typed contract read by form-field.component.ts to avoid clobbering an in-progress edit.
  get inputControl(): ElementRef<HTMLInputElement> | undefined {
    return this.tsInput?.inputElement();
  }

  constructor(private readonly destroyRef: DestroyRef) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.model[this.fieldDef.name];
    this._originalValue = this.value;

    this.control.setValue(this.value, { emitEvent: false });
    this.updateDisabledState();

    this.control.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
      this.value = value;
    });
  }

  ngDoCheck(): void {
    this.updateDisabledState();
  }

  edit(): void {
    if (!this.editing && !this.isReadonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl?.nativeElement.focus();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  visitUrl(): void {
    const normalizedUrl = FormFieldUtils.normalizeUrlForNavigation(this.value);

    if (!normalizedUrl) return;

    window.open(normalizedUrl, '_blank', 'noopener,noreferrer');
  }

  updateChangedModel(model: any): void {}

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  private updateDisabledState(): void {
    if (this.isDisabled === this.control.disabled) {
      return;
    }

    if (this.isDisabled) {
      this.control.disable({ emitEvent: false });
    } else {
      this.control.enable({ emitEvent: false });
    }
  }
}
